import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { PortDeleteConfirmPopupComponent } from './port-delete-confirm-popup.component';

@NgModule({
  declarations: [PortDeleteConfirmPopupComponent],
  imports: [
    CommonModule,
    MatDialogModule,
    MatIconModule,
    MatButtonModule,
  ],
  exports: [PortDeleteConfirmPopupComponent],
})
export class PortDeleteConfirmPopupModule {}
